import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ApplicationContext } from 'src/app/model';
import { UserContextPermissionRoleService } from 'src/app/services';
import { GlobalStateService } from 'src/app/services/global-state/global-state.service';

@Injectable({
  providedIn: 'root',
})
export class AppGuard implements CanActivate {
  constructor(
    private userContextPermissionRoleService: UserContextPermissionRoleService,
    private router: Router,
    private globalStateService: GlobalStateService
  ) {}

  private reroute(): boolean {
    return false;
  }

  public async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    let appContext: ApplicationContext =
      this.globalStateService.getWorkpaperContextData();
   

    if (appContext.clientId && (appContext.entityId || this.globalStateService.isRGWorkpaper())) {
      try {
        const result = await firstValueFrom(this.userContextPermissionRoleService.loadAccessInfo(appContext));
        const accessInfo = this.userContextPermissionRoleService.hasAccess(result);
        console.log('User has client access:', accessInfo);

        if (!accessInfo.hasAccess || accessInfo.isEntityLocked) {
          this.router.navigate(['/unauthorized']);
        }
      } catch (error) {
        return this.reroute();
      }
    }

    return true;
  }
}
